var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.chart ? `title-chart` : `title-block`,
        _vm.size ? `title-block__size--${_vm.size}` : "",
        _vm.color ? `title-block__color--${_vm.color}` : "",
        _vm.type ? `title-block__type--${_vm.type}` : "",
        _vm.padding ? "title-spacing" : "",
      ],
    },
    [
      _c("h2", {
        class: [
          _vm.color !== "white" ? "title-block__text" : "title-block__title",
        ],
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _vm._v(" "),
      _vm.tipText
        ? _c("Tip", {
            staticClass: "tip-button-reg",
            attrs: { "tip-content": _vm.tipText },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.link
        ? _c(
            "nuxt-link",
            { staticClass: "title-block__link", attrs: { to: _vm.link } },
            [_vm._v("\n    See all\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }